import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "../lib/api";
import { useLang } from "../i18n";

export function LiveCounter() {
  const { t } = useLang();
  const [stats, setStats] = useState({ voices: 0, countries: 0, this_month: 0 });

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const { data } = await api.get("/stats");
        if (active) setStats(data);
      } catch (e) {
        /* silent */
      }
    };
    load();
    const id = setInterval(load, 8000);
    return () => {
      active = false;
      clearInterval(id);
    };
  }, []);

  const fmt = (n) => n.toLocaleString();

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.5 }}
      data-testid="live-counter"
      className="w-full rounded-panel bg-white p-5 shadow-soft"
    >
      <div className="flex items-center gap-2 text-sm text-textsec">
        <span className="relative flex h-2.5 w-2.5">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-dusty opacity-60" />
          <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-dusty" />
        </span>
        <span data-testid="counter-headline">
          <span className="font-semibold text-graphite">{fmt(stats.voices)}</span> {t("voices_heard")} · {t("updated_live")}
        </span>
      </div>
      <div className="mt-4 grid grid-cols-3 gap-3">
        {[
          { k: "voices", label: t("stat_voices"), v: stats.voices },
          { k: "countries", label: t("stat_countries"), v: stats.countries },
          { k: "month", label: t("stat_month"), v: stats.this_month },
        ].map((s) => (
          <div key={s.k} data-testid={`stat-${s.k}`} className="rounded-xl bg-softpink px-3 py-3 text-center">
            <div className="text-2xl font-semibold tracking-tight text-graphite">{fmt(s.v)}</div>
            <div className="mt-0.5 text-xs text-textsec">{s.label}</div>
          </div>
        ))}
      </div>
    </motion.div>
  );
}
